(function () {
  var PREVIEW_CDN_BASE = 'https://d20hv3s0hl8t6v.cloudfront.net';
  var RENDER_BATCH_SIZE = 80;
  var IMAGE_EXTS = {
    png: true,
    jpg: true,
    jpeg: true,
    gif: true,
    webp: true,
    bmp: true,
    tiff: true,
    tif: true,
    ico: true,
    psd: true
  };

  function isImage(path) {
    var ext = String(path || '').split('.').pop().toLowerCase();
    return !!IMAGE_EXTS[ext];
  }

  function fileName(path) {
    return String(path || '').split('/').pop() || '';
  }

  function fileCount(paths) {
    return (paths || []).filter(function (path) {
      return typeof path === 'string' && path.trim() !== '';
    }).length;
  }

  function previewUrl(productId, variantId, path) {
    var encodedPath = String(path || '').split('/').map(encodeURIComponent).join('/');
    return PREVIEW_CDN_BASE + '/previews/' + encodeURIComponent(productId) + '/' + encodeURIComponent(variantId) + '/' + encodedPath + '.jpg';
  }

  function buildTree(paths) {
    var root = { name: '', path: '', children: {} };
    paths.forEach(function (path) {
      if (!path || typeof path !== 'string') return;
      var parts = path.split('/').filter(Boolean);
      if (!parts.length) return;

      var node = root;
      var acc = '';
      parts.forEach(function (part) {
        acc = acc ? acc + '/' + part : part;
        if (!node.children[part]) {
          node.children[part] = { name: part, path: acc, children: {} };
        }
        node = node.children[part];
      });
    });
    return root;
  }

  function sortedChildren(node) {
    return Object.keys(node.children).map(function (key) {
      return node.children[key];
    }).sort(function (a, b) {
      var aFile = Object.keys(a.children).length === 0;
      var bFile = Object.keys(b.children).length === 0;
      if (aFile !== bFile) return aFile ? 1 : -1;
      return a.name.localeCompare(b.name);
    });
  }

  function svgIcon(type) {
    if (type === 'spacer') {
      var spacer = document.createElement('span');
      spacer.className = 'layerstore-package-tree__spacer';
      spacer.setAttribute('aria-hidden', 'true');
      return spacer;
    }

    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('layerstore-package-tree__icon');
    svg.classList.add('layerstore-package-tree__icon--' + type);

    if (type === 'caret') {
      svg.setAttribute('viewBox', '0 0 20 20');
      svg.innerHTML = '<path d="M7 4.5 13 10l-6 5.5V4.5Z" fill="currentColor"/>';
    } else if (type === 'package') {
      svg.innerHTML = '<path d="M12 2.5 3.5 6.8v10.4L12 21.5l8.5-4.3V6.8L12 2.5Zm0 2.3 4.9 2.5L12 9.8 7.1 7.3 12 4.8Zm-6.5 4 5.5 2.8v6.8l-5.5-2.8V8.8Zm7.5 9.6v-6.8l5.5-2.8v6.8L13 18.4Z" fill="currentColor"/>';
    } else if (type === 'folder') {
      svg.innerHTML = '<path d="M10 4H4.5A2.5 2.5 0 0 0 2 6.5v11A2.5 2.5 0 0 0 4.5 20h15a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 19.5 6H12l-2-2Z" fill="currentColor"/>';
    } else if (type === 'image') {
      svg.innerHTML = '<rect x="3.5" y="4.5" width="17" height="15" rx="2" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="8.5" cy="9.5" r="1.7" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="m4.8 17.3 4.8-4.4 3.4 3 4-4 2.2 2.4" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>';
    } else {
      svg.innerHTML = '<path d="M13 3H6.5A2.5 2.5 0 0 0 4 5.5v13A2.5 2.5 0 0 0 6.5 21h11a2.5 2.5 0 0 0 2.5-2.5V10l-7-7Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M13 3v7h7" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>';
    }
    return svg;
  }

  function renderPreview(panel, productId, selection) {
    panel.replaceChildren();

    var card = document.createElement('div');
    card.className = 'layerstore-package-preview__card';
    var stage = document.createElement('div');
    stage.className = 'layerstore-package-preview__stage';

    if (!selection) {
      var empty = document.createElement('p');
      empty.className = 'layerstore-package-preview__message';
      empty.textContent = 'Select an image file to preview it.';
      stage.appendChild(empty);
    } else if (!isImage(selection.path)) {
      var nonImage = document.createElement('p');
      nonImage.className = 'layerstore-package-preview__message';
      nonImage.textContent = 'Only image files can be previewed.';
      stage.appendChild(nonImage);
    } else if (!selection.previewsReady) {
      var pending = document.createElement('p');
      pending.className = 'layerstore-package-preview__message';
      pending.textContent = 'Preview is still being generated.';
      stage.appendChild(pending);
    } else if (!productId) {
      var missingId = document.createElement('p');
      missingId.className = 'layerstore-package-preview__message';
      missingId.textContent = 'Preview is unavailable for this product.';
      stage.appendChild(missingId);
    } else {
      var img = document.createElement('img');
      img.className = 'layerstore-package-preview__image';
      img.alt = fileName(selection.path);
      img.src = previewUrl(productId, selection.variantId, selection.path);
      img.addEventListener('error', function () {
        stage.replaceChildren();
        var error = document.createElement('p');
        error.className = 'layerstore-package-preview__message';
        error.textContent = 'Preview image was not found.';
        stage.appendChild(error);
      });
      stage.appendChild(img);
    }

    var label = document.createElement('p');
    label.className = 'layerstore-package-preview__label';
    label.textContent = selection ? fileName(selection.path) : 'No file selected';

    card.appendChild(stage);
    card.appendChild(label);
    panel.appendChild(card);
  }

  function renderStatus(container, message, isLoading) {
    var status = document.createElement('div');
    status.className = 'layerstore-package-tree__status';

    if (isLoading) {
      var spinner = document.createElement('span');
      spinner.className = 'layerstore-package-tree__spinner';
      spinner.setAttribute('aria-hidden', 'true');
      status.appendChild(spinner);
    }

    var text = document.createElement('p');
    text.textContent = message;
    status.appendChild(text);

    container.replaceChildren(status);
    container.hidden = false;
    showPackageTab(container);
  }

  function renderLoading(container) {
    renderStatus(container, 'Loading package contents...', true);
  }

  function renderUnavailable(container) {
    renderStatus(container, 'Package contents are unavailable for this product.', false);
  }

  function selectFile(button, state, selection) {
    state.selected = selection;
    if (state.selectedButton && state.selectedButton !== button) {
      state.selectedButton.classList.remove('is-selected');
    }
    state.selectedButton = button;
    button.classList.add('is-selected');
    renderPreview(state.previewPanel, state.productId, state.selected);
  }

  function scheduleRender(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 100 });
      return;
    }
    window.setTimeout(function () {
      callback({
        didTimeout: true,
        timeRemaining: function () { return 0; }
      });
    }, 0);
  }

  function renderChildrenInBatches(parent, children, depth, variant, state, onComplete) {
    var index = 0;
    var progress = document.createElement('p');
    progress.className = 'layerstore-package-tree__progress';
    progress.setAttribute('role', 'status');
    progress.textContent = 'Loading items...';
    parent.appendChild(progress);
    parent.setAttribute('aria-busy', 'true');

    function renderBatch(deadline) {
      var fragment = document.createDocumentFragment();
      var rendered = 0;

      while (
        index < children.length &&
        rendered < RENDER_BATCH_SIZE &&
        (rendered < 20 || deadline.didTimeout || deadline.timeRemaining() > 2)
      ) {
        fragment.appendChild(renderNode(children[index], depth, variant, state));
        index += 1;
        rendered += 1;
      }

      parent.insertBefore(fragment, progress);
      if (index < children.length) {
        progress.textContent = 'Loading items... ' + index + ' / ' + children.length;
        scheduleRender(renderBatch);
        return;
      }

      progress.remove();
      parent.removeAttribute('aria-busy');
      if (onComplete) onComplete();
    }

    scheduleRender(renderBatch);
  }

  function renderNode(node, depth, variant, state) {
    var children = sortedChildren(node);
    var isFile = children.length === 0;

    if (isFile) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'layerstore-package-tree__row layerstore-package-tree__file';
      button.style.setProperty('--depth', depth);
      button.appendChild(svgIcon('spacer'));
      button.appendChild(svgIcon(isImage(node.path) ? 'image' : 'document'));
      var name = document.createElement('span');
      name.className = 'layerstore-package-tree__name';
      name.textContent = node.name;
      button.appendChild(name);
      button.addEventListener('click', function () {
        selectFile(button, state, {
          variantId: variant.id,
          previewsReady: !!variant.previewsReady,
          path: node.path
        });
      });
      return button;
    }

    var details = document.createElement('details');
    details.className = 'layerstore-package-tree__folder';

    var summary = document.createElement('summary');
    summary.className = 'layerstore-package-tree__row layerstore-package-tree__folder-summary';
    summary.style.setProperty('--depth', depth);
    summary.appendChild(svgIcon('caret'));
    summary.appendChild(svgIcon('folder'));
    var folderName = document.createElement('span');
    folderName.className = 'layerstore-package-tree__name';
    folderName.textContent = node.name;
    summary.appendChild(folderName);
    var count = document.createElement('span');
    count.className = 'layerstore-package-tree__child-count';
    count.textContent = children.length;
    summary.appendChild(count);
    details.appendChild(summary);

    var childWrap = document.createElement('div');
    childWrap.className = 'layerstore-package-tree__children';
    details.appendChild(childWrap);
    details.dataset.childrenLoaded = 'false';
    details.addEventListener('toggle', function () {
      if (!details.open || details.dataset.childrenLoaded !== 'false') return;
      details.dataset.childrenLoaded = 'loading';
      renderChildrenInBatches(childWrap, children, depth + 1, variant, state, function () {
        details.dataset.childrenLoaded = 'true';
      });
    });
    return details;
  }

  function hydrateVariant(details, tree, variant, state) {
    if (details.dataset.treeLoaded !== 'false') return;
    details.dataset.treeLoaded = 'loading';
    tree.setAttribute('aria-busy', 'true');

    var status = document.createElement('p');
    status.className = 'layerstore-package-tree__progress';
    status.setAttribute('role', 'status');
    status.textContent = 'Preparing package contents...';
    tree.appendChild(status);

    scheduleRender(function () {
      var children = sortedChildren(buildTree(variant.fileTree));
      tree.replaceChildren();
      tree.removeAttribute('aria-busy');
      renderChildrenInBatches(tree, children, 1, variant, state, function () {
        details.dataset.treeLoaded = 'true';
      });
    });
  }

  function render(container, result) {
    var variants = (result && result.variants || []).filter(function (variant) {
      return fileCount(variant.fileTree) > 0;
    });
    if (!variants.length) {
      renderUnavailable(container);
      return;
    }

    var shell = document.createElement('div');
    shell.className = 'layerstore-package-tree__shell';

    var list = document.createElement('div');
    list.className = 'layerstore-package-tree__list';
    var preview = document.createElement('div');
    preview.className = 'layerstore-package-preview';

    var state = {
      root: shell,
      productId: result && result.id,
      selected: null,
      selectedButton: null,
      previewPanel: preview
    };

    variants.forEach(function (variant) {
      var details = document.createElement('details');
      details.className = 'layerstore-package-tree__variant';

      var summary = document.createElement('summary');
      summary.className = 'layerstore-package-tree__variant-summary';
      summary.appendChild(svgIcon('caret'));
      summary.appendChild(svgIcon('package'));
      var name = document.createElement('span');
      name.className = 'layerstore-package-tree__variant-name';
      name.textContent = variant.name || 'Package';
      summary.appendChild(name);
      var count = document.createElement('span');
      count.className = 'layerstore-package-tree__child-count';
      count.textContent = fileCount(variant.fileTree).toLocaleString() + ' files';
      summary.appendChild(count);

      details.appendChild(summary);

      var tree = document.createElement('div');
      tree.className = 'layerstore-package-tree__variant-tree';
      details.dataset.treeLoaded = 'false';
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        hydrateVariant(details, tree, variant, state);
      });
      details.appendChild(tree);
      list.appendChild(details);
    });

    shell.appendChild(list);
    shell.appendChild(preview);
    container.replaceChildren(shell);
    container.hidden = false;
    showPackageTab(container);
    renderPreview(preview, state.productId, state.selected);
  }

  function loadProductId(apiBase, slug, result) {
    if (result && result.id) return Promise.resolve(result);
    return fetch(apiBase + '/products/' + encodeURIComponent(slug))
      .then(function (res) {
        if (!res.ok) return result;
        return res.json();
      })
      .then(function (data) {
        if (data && data.status === 'SUCCESS' && data.result && data.result.id) {
          result.id = data.result.id;
        }
        return result;
      })
      .catch(function () {
        return result;
      });
  }

  function setPanelActive(panel, active) {
    panel.classList.toggle('is-active', active);
    panel.hidden = !active;
    panel.setAttribute('aria-hidden', active ? 'false' : 'true');

    if (active) {
      panel.style.removeProperty('display');
      panel.style.removeProperty('visibility');
      panel.style.removeProperty('height');
      panel.style.removeProperty('min-height');
      panel.style.removeProperty('overflow');
      panel.style.removeProperty('margin');
      panel.style.removeProperty('padding');
      panel.style.removeProperty('border');
      return;
    }

    panel.style.setProperty('display', 'none', 'important');
    panel.style.setProperty('visibility', 'hidden', 'important');
    panel.style.setProperty('height', '0', 'important');
    panel.style.setProperty('min-height', '0', 'important');
    panel.style.setProperty('overflow', 'hidden', 'important');
    panel.style.setProperty('margin', '0', 'important');
    panel.style.setProperty('padding', '0', 'important');
    panel.style.setProperty('border', '0', 'important');
  }

  function selectTab(tabs, name, group) {
    group = group || 'primary';
    var desktopMode = group === 'desktop';
    tabs.querySelectorAll('[data-layerstore-tab-button]').forEach(function (button) {
      var buttonGroup = button.dataset.layerstoreTabGroup || 'primary';
      if (desktopMode ? buttonGroup !== 'desktop' : buttonGroup !== group) return;
      var active = button.dataset.layerstoreTabButton === name;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    tabs.querySelectorAll('[data-layerstore-tab-panel]').forEach(function (panel) {
      var panelGroup = panel.dataset.layerstoreTabGroup || 'primary';
      if (!desktopMode && panelGroup !== group) return;
      var active = panel.dataset.layerstoreTabPanel === name;
      if (!desktopMode && panel.dataset.layerstoreTabPanel === 'review') {
        active = true;
      }
      setPanelActive(panel, active);
    });

    normalizeReviewWidgets(tabs);
  }

  function forceReviewLinkColors(root) {
    (root || document)
      .querySelectorAll('.jdgm-all-reviews-text, .jdgm-all-reviews-text *, .jdgm-rev-widg__summary a, .jdgm-rev-widg__summary a *')
      .forEach(function (element) {
        element.style.setProperty('color', '#F8F9FA', 'important');
        element.style.setProperty('opacity', '1', 'important');
        element.style.setProperty('text-decoration-color', '#F8F9FA', 'important');
      });

    (root || document).querySelectorAll('a, button, span').forEach(function (element) {
      if ((element.textContent || '').trim().toLowerCase() !== 'see all reviews') return;
      element.style.setProperty('color', '#F8F9FA', 'important');
      element.style.setProperty('opacity', '1', 'important');
      element.style.setProperty('text-decoration-color', '#F8F9FA', 'important');
      });
  }

  function setImportantStyle(element, property, value) {
    if (!element) return;
    element.style.setProperty(property, value, 'important');
  }

  function forceReviewStackLayout(panel) {
    if (!panel) return;

    var reviewRoot = panel.querySelector('.layerstore-product-tabs__review');
    var widget = panel.querySelector('.jdgm-widget');
    var reviewWidget = panel.querySelector('.jdgm-rev-widg');
    var header = panel.querySelector('.jdgm-rev-widg__header');
    var summary = panel.querySelector('.jdgm-rev-widg__summary');
    var histogram = panel.querySelector('.jdgm-histogram');
    var actionElements = Array.prototype.slice.call(
      panel.querySelectorAll('.jdgm-widget-actions-wrapper, .jdgm-rev-widg__actions')
    );

    [panel, reviewRoot, widget, reviewWidget].forEach(function (element) {
      setImportantStyle(element, 'box-sizing', 'border-box');
      setImportantStyle(element, 'width', '100%');
      setImportantStyle(element, 'max-width', '100%');
      setImportantStyle(element, 'overflow', 'hidden');
    });

    if (!header) return;

    setImportantStyle(header, 'display', 'flex');
    setImportantStyle(header, 'flex-direction', 'column');
    setImportantStyle(header, 'flex-wrap', 'nowrap');
    setImportantStyle(header, 'align-items', 'center');
    setImportantStyle(header, 'justify-content', 'flex-start');
    setImportantStyle(header, 'gap', '2.4rem');
    setImportantStyle(header, 'width', 'min(100%, 64rem)');
    setImportantStyle(header, 'max-width', '64rem');
    setImportantStyle(header, 'margin', '0 auto 2.8rem');
    setImportantStyle(header, 'text-align', 'center');
    setImportantStyle(header, 'float', 'none');
    setImportantStyle(header, 'clear', 'both');
    setImportantStyle(header, 'position', 'static');
    setImportantStyle(header, 'transform', 'none');

    [summary, histogram].concat(actionElements).forEach(function (element) {
      if (!element) return;
      setImportantStyle(element, 'display', element.classList.contains('jdgm-rev-widg__actions') || element.classList.contains('jdgm-widget-actions-wrapper') ? 'flex' : 'block');
      setImportantStyle(element, 'float', 'none');
      setImportantStyle(element, 'clear', 'both');
      setImportantStyle(element, 'position', 'static');
      setImportantStyle(element, 'inset', 'auto');
      setImportantStyle(element, 'transform', 'none');
      setImportantStyle(element, 'box-sizing', 'border-box');
      setImportantStyle(element, 'width', '100%');
      setImportantStyle(element, 'max-width', '56rem');
      setImportantStyle(element, 'margin-left', 'auto');
      setImportantStyle(element, 'margin-right', 'auto');
      setImportantStyle(element, 'flex', '0 0 auto');
    });

    if (summary) setImportantStyle(summary, 'order', '1');
    if (histogram) setImportantStyle(histogram, 'order', '2');

    actionElements.forEach(function (actions) {
      setImportantStyle(actions, 'order', '3');
      setImportantStyle(actions, 'align-items', 'center');
      setImportantStyle(actions, 'justify-content', 'center');
      setImportantStyle(actions, 'margin-top', '0');
      setImportantStyle(actions, 'margin-bottom', '0');
    });

    panel.querySelectorAll('.jdgm-write-rev-link, .jdgm-btn--solid').forEach(function (button) {
      setImportantStyle(button, 'display', 'inline-flex');
      setImportantStyle(button, 'align-items', 'center');
      setImportantStyle(button, 'justify-content', 'center');
      setImportantStyle(button, 'width', '100%');
      setImportantStyle(button, 'max-width', '56rem');
      setImportantStyle(button, 'min-height', '5.6rem');
      setImportantStyle(button, 'background', '#F8F9FA');
      setImportantStyle(button, 'border-color', '#F8F9FA');
      setImportantStyle(button, 'color', '#1b1b1b');
      setImportantStyle(button, 'font-weight', '700');
      setImportantStyle(button, 'text-decoration', 'none');
    });
  }

  function normalizeReviewWidgets(root) {
    var reviewRoot = root || document;
    var reviewPanels = [];

    forceReviewLinkColors(reviewRoot);

    if (
      reviewRoot.nodeType === 1 &&
      reviewRoot.matches &&
      reviewRoot.matches('[id^="LayerStoreReview-"]')
    ) {
      reviewPanels.push(reviewRoot);
    }

    reviewRoot.querySelectorAll('[id^="LayerStoreReview-"]').forEach(function (panel) {
      if (reviewPanels.indexOf(panel) === -1) {
        reviewPanels.push(panel);
      }
    });

    reviewPanels.forEach(function (panel) {
      var header = panel.querySelector('.jdgm-rev-widg__header');
      if (!header) {
        forceReviewStackLayout(panel);
        forceReviewLinkColors(panel);
        return;
      }

      var summary = panel.querySelector('.jdgm-rev-widg__summary');
      var histogram = panel.querySelector('.jdgm-histogram');
      var actions = panel.querySelector('.jdgm-widget-actions-wrapper') || panel.querySelector('.jdgm-rev-widg__actions');

      [summary, histogram, actions].forEach(function (element) {
        if (!element || element.parentNode === header) return;
        header.appendChild(element);
      });

      panel.classList.add('layerstore-review-normalized');
      header.classList.add('layerstore-review-normalized__header');

      forceReviewStackLayout(panel);
      forceReviewLinkColors(panel);
    });
  }

  function watchReviewWidgets(root) {
    (root || document).querySelectorAll('[id^="LayerStoreReview-"]').forEach(function (panel) {
      if (panel.dataset.reviewNormalizeReady === 'true') return;
      panel.dataset.reviewNormalizeReady = 'true';

      var scheduled = false;
      var scheduleNormalize = function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          normalizeReviewWidgets(panel);
        });
      };

      scheduleNormalize();

      if (!window.MutationObserver) return;
      var observer = new MutationObserver(scheduleNormalize);
      observer.observe(panel, {
        childList: true,
        subtree: true
      });
    });
  }

  function watchReviewLinks() {
    if (!document.body || document.body.dataset.layerstoreReviewLinksReady === 'true') return;
    document.body.dataset.layerstoreReviewLinksReady = 'true';

    var scheduled = false;
    var scheduleNormalize = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        document.querySelectorAll('[id^="LayerStoreReview-"]').forEach(function (panel) {
          forceReviewLinkColors(panel);
        });
      });
    };

    scheduleNormalize();

    window.setTimeout(scheduleNormalize, 500);
    window.setTimeout(scheduleNormalize, 1500);
    window.setTimeout(scheduleNormalize, 3000);
  }

  function syncTabsForViewport(tabs) {
    if (window.matchMedia('(max-width: 1279px)').matches) {
      selectTab(tabs, 'description', 'primary');
    } else {
      selectTab(tabs, 'description', 'desktop');
    }
  }

  function placeMobileSecondaryTabs(tabs) {
    var isMobile = window.matchMedia('(max-width: 1279px)').matches;
    var productSection = tabs.closest('[id^="MainProduct-"]') || document;
    var shareBlock = productSection.querySelector('.product-meta-block--share');
    var reviewPanel = tabs.querySelector('[data-layerstore-tab-panel="review"]') ||
      productSection.querySelector('[data-layerstore-tab-panel="review"]');
    var secondaryNav = tabs.querySelector('.layerstore-product-tabs__nav--secondary');
    var secondaryPanels = tabs.querySelector('.layerstore-product-tabs__panels--secondary');
    var releaseAccordion = tabs.querySelector('[data-layerstore-mobile-release]');

    [reviewPanel, secondaryNav, secondaryPanels, releaseAccordion].forEach(function (element) {
      if (!element || element._originalParent) return;
      element._originalParent = element.parentNode;
      element._originalNextSibling = element.nextSibling;
    });

    if (!isMobile || !shareBlock) {
      [reviewPanel, secondaryNav, secondaryPanels, releaseAccordion].forEach(function (element) {
        if (!element) return;
        element.classList.remove('layerstore-product-tabs__mobile-after-share');
        element.classList.remove('layerstore-product-tabs__mobile-review');
        if (element.parentNode === element._originalParent) return;
        element._originalParent.insertBefore(element, element._originalNextSibling);
      });
      return;
    }

    if (releaseAccordion && (releaseAccordion.parentNode !== shareBlock.parentNode || shareBlock.nextSibling !== releaseAccordion)) {
      shareBlock.parentNode.insertBefore(releaseAccordion, shareBlock.nextSibling);
    }
    if (releaseAccordion) {
      releaseAccordion.classList.add('layerstore-product-tabs__mobile-after-share');
    }

    if (reviewPanel) {
      var reviewAnchor = releaseAccordion && releaseAccordion.parentNode === shareBlock.parentNode ? releaseAccordion : shareBlock;
      if (reviewPanel.parentNode !== shareBlock.parentNode || reviewAnchor.nextSibling !== reviewPanel) {
        shareBlock.parentNode.insertBefore(reviewPanel, reviewAnchor.nextSibling);
      }
      reviewPanel.classList.add('layerstore-product-tabs__mobile-after-share', 'layerstore-product-tabs__mobile-review');
      setPanelActive(reviewPanel, true);
      normalizeReviewWidgets(reviewPanel);
    }
  }

  function initTabs(tabs) {
    if (tabs.dataset.tabsReady === 'true') return;
    tabs.dataset.tabsReady = 'true';

    syncTabsForViewport(tabs);
    placeMobileSecondaryTabs(tabs);

    tabs.querySelectorAll('[data-layerstore-tab-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        selectTab(tabs, button.dataset.layerstoreTabButton, button.dataset.layerstoreTabGroup);
      });
    });
  }

  function showPackageTab(container) {
    var tabs = container.closest('[data-layerstore-product-tabs]');
    if (!tabs) return;
    var panel = tabs.querySelector('[data-layerstore-tab-panel="package"]');
    tabs.querySelectorAll('[data-layerstore-tab-button="package"]').forEach(function (button) {
      button.hidden = false;
    });
    if (!panel) return;

    // Desktop and mobile tab controls coexist in the DOM. The hidden control can
    // keep its own active state, so it must not decide whether this shared panel
    // is visible after the package tree starts rendering.
    var active = panel.classList.contains('is-active');
    panel.hidden = !active;
    panel.setAttribute('aria-hidden', active ? 'false' : 'true');
  }

  function init(container) {
    if (container.dataset.packageTreeLoaded === 'true') return;
    container.dataset.packageTreeLoaded = 'true';
    var slug = container.dataset.slug;
    var apiBase = (container.dataset.apiBase || '').replace(/\/$/, '');
    renderLoading(container);
    if (!slug || !apiBase) {
      renderUnavailable(container);
      return;
    }
    fetch(apiBase + '/products/' + encodeURIComponent(slug) + '/package-tree')
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        if (!data || data.status !== 'SUCCESS') {
          renderUnavailable(container);
          return;
        }
        return loadProductId(apiBase, slug, data.result).then(function (result) {
          render(container, result);
        });
      })
      .catch(function () {
        renderUnavailable(container);
      });
  }

  function prepare(container) {
    if (container.dataset.packageTreePrepared === 'true') return;
    container.dataset.packageTreePrepared = 'true';
    showPackageTab(container);

    var tabs = container.closest('[data-layerstore-product-tabs]');
    if (!tabs) return;
    var buttons = tabs.querySelectorAll('[data-layerstore-tab-button="package"]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        init(container);
      }, { once: true });
      if (button.classList.contains('is-active')) init(container);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-layerstore-product-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-layerstore-package-tree]').forEach(prepare);
    normalizeReviewWidgets(document);
    watchReviewWidgets(document);
    watchReviewLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  var isMobileViewport = window.matchMedia('(max-width: 1279px)').matches;
  window.addEventListener('resize', function () {
    var nextIsMobileViewport = window.matchMedia('(max-width: 1279px)').matches;
    if (nextIsMobileViewport === isMobileViewport) return;
    isMobileViewport = nextIsMobileViewport;
    document.querySelectorAll('[data-layerstore-product-tabs]').forEach(function (tabs) {
      placeMobileSecondaryTabs(tabs);
      syncTabsForViewport(tabs);
    });
  });
})();
